define(['jquery'], function($) {

	/**
	 * Osetreni moznosti psani znaku v ramci komponenty $element, ktere odpovidaji danemu patternu
	 * @param $element Komponenta (text input, textarea...)
	 * @param pattern Regularni vyraz, ktery povoluje pouze znaky, ktere mu odpovidaji
	 */
	const handleKeyPress = function($element, pattern) {
		$element.off('keypress.pattern').on('keypress.pattern', function (e){
			var result = pattern.test(String.fromCharCode(e.which));

			if ((($.inArray(e.keyCode, [9, 27, 13, 46, 110, 190]) !== -1) && (e.which == 0))  ||
					(e.keyCode == 8) ||
				// Allow: Ctrl+A
					(e.keyCode == 65 && e.ctrlKey === true) ||
				// Allow: Ctrl+C
					(e.keyCode == 67 && e.ctrlKey === true) ||
				// Allow: Ctrl+X
					(e.keyCode == 88 && e.ctrlKey === true) ||
				// Allow: home, end, left, right
					(e.keyCode >= 35 && e.keyCode <= 39)) {
				// let it happen, don't do anything
				return;
			}

			if (result) {
				return result;
			}
			else {
				e.preventDefault();
			}
		});
	};

	// inicializace moznosti vkladat jen urcite znaky
	const initKeyPress = function() {
		$('.form-control[data-pattern]').each(function(){
			var pattern = $(this).data('pattern');
			if (pattern.indexOf('phoneNumber') == 0) {
				handleKeyPress($(this),/^[0-9]|[\+]+$/);
			}
			if (pattern.indexOf('number') == 0) {
				handleKeyPress($(this),/^[0-9]+$/);
			}
			if (pattern.indexOf('floatNumber') == 0) {
				handleKeyPress($(this), /^[0-9]|[\,]+$/);
			}
			if (pattern.indexOf('zip') == 0) {
				handleKeyPress($(this),/^[0-9]|[\s]$/);
			}
			if (pattern.indexOf('alphanumeric') == 0) {
				handleKeyPress($(this),/^[0-9]|[a-z]|[A-Z]+$/);
			}
			if (pattern.indexOf('dic') == 0) {
				handleKeyPress($(this),/^[A-Z]|[0-9]+$/);
			}
			if (pattern.indexOf('icoRc') == 0) {
				handleKeyPress($(this),/^[0-9|\.|\/]+$/);
			}
			if (pattern.indexOf('word') == 0) {
				handleKeyPress($(this),/^[a-z]|[A-Z]|[ČŘŽěščřžýáíéůúťďňóöäëü\- ]+$/);
			}
		});
	};

	initKeyPress();

	$(document).on('afterContentsReplaced', function() {
		initKeyPress();
	});
});



// WEBPACK FOOTER //
// ./config/fe/web-default/src/js/web/jquery.formControlPattern.js